import { Component, Inject } from '@angular/core';
// angular module
import { CommonModule, NgIf } from '@angular/common';
// import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  showModal: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('モーダルデータ:', JSON.stringify(this.data));
    if (Object.keys(this.data).length > 0) {
      this.showModal = true;
    }
  }

  onClick(type: string = ''): void {
    this.dialogRef.close(type);
    this.showModal = false;
  }
}
